var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleChevronRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.34,
    height: 29.339,
    viewBox: "0 0 29.34 29.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-chevron-right",
    d: "M14.67,0A14.67,14.67,0,1,0,29.34,14.67,14.669,14.669,0,0,0,14.67,0Zm5.879,15.965-6.418,6.418a1.834,1.834,0,1,1-2.593-2.593l5.126-5.12L11.541,9.547a1.834,1.834,0,0,1,2.593-2.593l6.418,6.418a1.828,1.828,0,0,1,.536,1.3A1.808,1.808,0,0,1,20.549,15.965Z",
    fill: "#00a8ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChevronRight);
export default __webpack_public_path__ + "static/media/circle-chevron-right.21f30d635e7f32b602b59379a219b48d.svg";
export { ForwardRef as ReactComponent };